exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".items-loader[data-v-213ec862] {\n  cursor: pointer;\n  font-weight: 600;\n}\n.configuration-header[data-v-213ec862] {\n  min-width: 200px;\n}", ""]);

// exports
